import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 text-center text-sm font-medium text-green-600"
}

import TextLink from '@/components/TextLink.vue';
import { Button } from '@/components/ui/button';
import AuthLayout from '@/layouts/AuthLayout.vue';
import { Head, useForm } from '@inertiajs/vue3';
import { LoaderCircle } from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'VerifyEmail',
  props: {
    status: {}
  },
  setup(__props: any) {



const form = useForm({});

const submit = () => {
    form.post(route('verification.send'));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthLayout, {
    title: "Verify email",
    description: "Please verify your email address by clicking on the link we just emailed to you."
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Head), { title: "Email verification" }),
      (_ctx.status === 'verification-link-sent')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " A new verification link has been sent to the email address you provided during registration. "))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _withModifiers(submit, ["prevent"]),
        class: "space-y-6 text-center"
      }, [
        _createVNode(_unref(Button), {
          disabled: _unref(form).processing,
          variant: "secondary"
        }, {
          default: _withCtx(() => [
            (_unref(form).processing)
              ? (_openBlock(), _createBlock(_unref(LoaderCircle), {
                  key: 0,
                  class: "h-4 w-4 animate-spin"
                }))
              : _createCommentVNode("", true),
            _cache[0] || (_cache[0] = _createTextVNode(" Resend verification email "))
          ]),
          _: 1,
          __: [0]
        }, 8, ["disabled"]),
        _createVNode(TextLink, {
          href: _ctx.route('logout'),
          method: "post",
          as: "button",
          class: "mx-auto block text-sm"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Log out ")
          ])),
          _: 1,
          __: [1]
        }, 8, ["href"])
      ], 32)
    ]),
    _: 1
  }))
}
}

})